import { ReactElement } from "react";

import { PaywallConfig } from "@voxmedia/duet-context/context/config-context";
import { Paywall, Growl, Regwall } from "@voxmedia/duet-ui/components/paywall";
import vergeLight from "@voxmedia/duet-ui/themes/theverge-light.css";

const config: PaywallConfig = {
  excludedArticleTypes: [
    "homepage",
    "category",
    "account",
    "memberships",
    "page",
    "search_results",
    "auth",
    "newsletters",
    "error",
    "author_profile",
    "package",
    "stream",
    "quick_post",
  ],
  isWalled: true,
  meterExceptions: ["advertiser-content", "paywall-never"],
  subXTrackingEnabled: true,
  showWallForEditorialSponsorship: true,
};

/**
 * Zephr template configuration for remote HTML template loading.
 * Each template is a function that returns a React element to be
 * rendered via renderToStaticMarkup.
 */
export const templates: Record<string, () => ReactElement> = {
  paywallDefault: () => <Paywall />,
  growlDefault: () => <Growl />,
  regwallDefault: () => <Regwall className={vergeLight} />,
};

export default config;
